module.exports = __webpack_public_path__ + "static/media/time-management.f9261f27.png";